/**
 * Created by hyr on 18/11/4.
 * 调用分享面板
 * 文案配置在config.share.js中
 * 用法：
 * import Share from './Share';
 * let ShareController = new Share();
 * ShareController.shareModule(function(){
 *     //分享成功后的逻辑
 * });
 */
import amapApp from '@ali/amap-lib';
import shareData from '../../config/config.share';
import aosUrl from "../../config/config.aos";
import ACTDATA from "../../config/config.act";
const _shareData = JSON.parse(JSON.stringify(shareData));
const isWX = window.navigator.userAgent.search(/MicroMessenger/i) >= 0;
export default class Share {
  constructor() {
    this.disable = null;
    this.isAmap = false;
    this.hasPY = true;
    this.shareData = {
      wx: {},//微信端微信分享数据
      wx_pengyou: {},//微信端朋友圈分享数据
      amap: [],//高德客户端分享数据
    };
    this.getShareData();
    this.init();
    this.initShareData();
  }

  init() {
    const _this = this;
    if (isWX) {
      //微信分享逻辑
      console.log('微信端');
      amapApp.util.addScript(location.protocol + '//cache.amap.com/activity/tools/jweixin-1.0.0.js', () => {
        amapApp.util.addScript(location.protocol + '//wb.amap.com/sign.php?r=' + Math.random(), () => {
          wx.ready(() => {
            wx.checkJsApi({
              jsApiList: [
                'hideMenuItems', // 屏蔽传播类功能
                // 'onMenuShareTimeline', // 分享到朋友圈
                // 'onMenuShareAppMessage' // 分享给好友
              ],
              success(res) {
                _this.updateList();
                console.log(res)
                console.log('微信：' + JSON.stringify(_this.shareData.wx));
                console.log('朋友圈：' + JSON.stringify(_this.shareData.wx_pengyou));
                if (res.checkResult.onMenuShareAppMessage) {
                  wx.onMenuShareAppMessage(_this.shareData.wx);
                }
                if (res.checkResult.onMenuShareTimeline) {
                  wx.onMenuShareTimeline(_this.shareData.wx_pengyou);
                }
                if (res.checkResult.hideMenuItems) {
                  console.log('隐藏传播功能')
                  wx.hideMenuItems({
                    menuList: ['menuItem:share:appMessage', 'menuItem:share:timeline', 'menuItem:share:qq', 'menuItem:share:weiboApp', 'menuItem:share:facebook', 'menuItem:share:QZone']
                  })
                }
              }
            })
          });
        });
      });
    } else {
      this.updateList();
      // console.log(this.shareData.amap);
    }
  }

  initShareData() {
    //初始化share数据 双向绑定
    const _this = this;
    Object.keys(_shareData).forEach((keys) => {
      Object.defineProperty(shareData, keys, {
        get(){
          return _shareData[keys];
        },
        set(value){
          _shareData[keys] = value;
          _this.updateShareData(keys);
        },
      });
    });
  }

  getShareData() {
    //服务控 朋友圈
    if (amapApp.webviewInfo.isInAmap()) {
      this.isAmap = true;
      amapApp.native.getAppInfo((res)=>{
        amapApp.loader.get(aosUrl.share_share_conf, [
          {tid: res.tid, sign: 1},
          {activity: ACTDATA.activity}
        ], (res) => {
          if (res.code == 1 && res.data && !res.data.pengyou) {
            this.hasPY = false;
            this.init();
          }
        });
      });
    }
  }

  updateShareData(type) {
    switch (type) {
      case 'list':
        this.updateList();
        break;
      case 'title':
        this.updateTitle();
        break;
      case 'wbTopic':
        this.updateWbTopic();
        break;
      case 'message':
        this.updateMessage();
        break;
      case 'imgUrl':
        this.updateImgUrl();
        break;
      case 'wbImgUrl':
        this.updateWbImgUrl();
        break;
      case 'url':
        this.updateUrl();
        break;
    }
    // console.log(this.shareData.amap);
  }

  updateList() {
    //更新list时的触发
    if (!isWX) {
      this.shareData.amap = [];
      _shareData.list.forEach((item) => {
        if (item != 'pengyou' || item == 'pengyou' && this.hasPY) {
          this.shareData.amap.push({type: item});
        }
      });
    }
    this.updateShare();
  }

  updateShare() {
    this.updateTitle();
    this.updateWbTopic();
    this.updateMessage();
    this.updateImgUrl();
    this.updateWbImgUrl();
    this.updateUrl();
  }

  updateTitle() {
    //更新分享title时的触发
    if (isWX) {
      this.shareData.wx.title = _shareData.title;
    } else {
      this.shareData.amap.forEach((item) => {
        if (item.type != 'pengyou') {
          item.title = _shareData.title;
        }
      });
    }
  }

  updateWbTopic() {
    //更新微博活动时的触发
    this.shareData.amap.forEach((item) => {
      if (item.type == 'weibo') {
        item.message = _shareData.wbTopic + _shareData.message;
      }
    });
  }

  updateMessage() {
    //更新分享文案时的触发
    if (isWX) {
      this.shareData.wx.desc = _shareData.message;
      this.shareData.wx_pengyou.title = _shareData.title;
    } else {
      this.shareData.amap.forEach((item) => {
        if (item.type != 'pengyou') {
          if (item.type == 'weibo') {
            item.message = _shareData.wbTopic + _shareData.message;
          } else {
            item.message = _shareData.message;
          }
        } else if (item.type == 'pengyou' && this.hasPY) {
          // item.title=_shareData.message;
          item.title = _shareData.title;
        }
      });
    }
  }

  updateImgUrl() {
    //更新分享图片时的触发
    if (isWX) {
      this.shareData.wx.imgUrl = _shareData.imgUrl;
      this.shareData.wx_pengyou.imgUrl = _shareData.imgUrl;
    } else {
      this.shareData.amap.forEach((item) => {
        if (item.type != 'weibo' || item.type != 'pengyou' || item.type == 'pengyou' && this.hasPY) {
          item.imgUrl = _shareData.imgUrl;
        }
      });
    }
  }

  updateWbImgUrl() {
    //更新微博分享图片时的触发
    this.shareData.amap.forEach((item) => {
      if (item.type == 'weibo') {
        item.imgUrl = _shareData.wbImgUrl;
      }
    });
  }

  updateUrl() {
    //更新分享链接时触发
    if (isWX) {
      // this.shareData.wx.link = amapApp.util.urlAddParam(_shareData.url, {isInAmap: 0, gd_from: 'weixin'});
      this.shareData.wx.link = _shareData.url;
      // this.shareData.wx_pengyou.link = amapApp.util.urlAddParam(_shareData.url, {
      //   isInAmap: 0,
      //   gd_from: 'pengyou'
      // });
      this.shareData.wx_pengyou.link = _shareData.url;
    } else {
      this.shareData.amap.forEach((item) => {
        // item.url = amapApp.util.urlAddParam(_shareData.url, {isInAmap: 0, gd_from: item.type});
        item.url = _shareData.url;
      });
    }
  }

  shareModule(cb) {
    if (!this.disable) {
      //防连点
      this.disable = setTimeout(() => {
        this.disable = null;
      }, 1000);
      if (this.isAmap) {
        //端内调用分享
        console.log(this.shareData.amap);
        amapApp.native.share(this.shareData.amap, (...arg) => {
          cb && cb.apply(null, arg);
        }, _shareData.hideMore);
      } else if (isWX) {
        //微信分享回调
        this.shareData.wx.success = ((...arg) => {
          return () => {
            cb && cb.apply(null, arg);
          }
        })('weixin', 'ok');
        this.shareData.wx.cancel = ((...arg) => {
          return () => {
            cb && cb.apply(null, arg);
          }
        })('weixin', 'cancel');
        this.shareData.wx.fail = ((...arg) => {
          return () => {
            cb && cb.apply(null, arg);
          }
        })('weixin', 'fail');

        this.shareData.wx_pengyou.success = ((...arg) => {
          return () => {
            cb && cb.apply(null, arg);
          }
        })('pengyou', 'ok');
        this.shareData.wx_pengyou.cancel = ((...arg) => {
          return () => {
            cb && cb.apply(null, arg);
          }
        })('pengyou', 'cancel');
        this.shareData.wx_pengyou.fail = ((...arg) => {
          return () => {
            cb && cb.apply(null, arg);
          }
        })('pengyou', 'fail');
      } else {
        console.log('端外无分享回调逻辑');
      }
    } else {
      clearTimeout(this.disable);
      this.disable = setTimeout(() => {
        this.disable = null;
      }, 1000);
    }
  }
}
